import i18next from 'i18next';

const INFINITE_DURATION_SENTINEL = 'PT9223372036854775807.807S';

export function createValueElement(
  formatter: Intl.NumberFormat,
  valueType?: string,
  value?: string,
): string | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }

  const normalizedType = valueType?.toLowerCase();

  if (
    normalizedType === 'duration' ||
    (typeof value === 'string' && value.startsWith('PT') && value.endsWith('S'))
  ) {
    if (value === INFINITE_DURATION_SENTINEL) {
      return '∞';
    }

    const extractedValue = value.match(/PT([\d.]+)S/)?.[1]; // Once js Temporal.Duration API is widely supported, we can use it instead of regex bs
    const seconds = Number.parseFloat(extractedValue ?? '0');
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = Math.round(seconds % 60);
    const hours = Math.floor(minutes / 60);
    const minutesLeft = Math.round(minutes % 60);
    if (hours > 0) {
      return `${hours}h ${minutesLeft}m ${secondsLeft}s`;
    }
    if (minutes > 0) {
      return `${minutes}m ${secondsLeft}s`;
    }
    return `${secondsLeft}s`;
  }

  switch (normalizedType) {
    case 'double':
    case 'float': {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value;
      }
      return formatter.format(num);
    }
    case 'boolean':
      return value === 'true' ? 'On' : 'Off';
    default:
      return value;
  }
}

export const applyFractionDigits = (fd?: number | null, useGrouping: boolean = true) =>
  new Intl.NumberFormat(i18next.resolvedLanguage, {
    maximumFractionDigits: fd ?? 1,
    minimumFractionDigits: fd ?? 1,
    useGrouping,
  });
